// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__WL3He","homeWidgets":"home_homeWidgets__2KRQL"};